import { Box, CategoryLink, Flex, SliderNavButton, Text, theme, Track, useSlider } from '@gassan-ui'
import React, { FC, useRef } from 'react'
import styled, { css, keyframes } from 'styled-components'
import { PositionProps } from 'styled-system'
import LocalizedLink from './Localization/LocalizedLink'
import { getKontentImage } from '@lib/kontent'

const NavBox = styled(Flex)`
  align-items: center;
  position: absolute;
  top: 50%;
  height: 100%;
  transform: translateY(-50%);
`

const catchClickAnimation = keyframes`
  0% {
    visibility: visible;
    pointer-events: all;
  }
  99%{
    visibility: visible;
    pointer-events: all;
  }

  100% {
    visibility: hidden;
    pointer-events: none;
  }
`

const CatchClick = styled.div<PositionProps & { animateOut: boolean }>`
  position: absolute;
  top: 0;
  width: 4rem;
  height: 100%;
  transition: all 2s ease;

  ${p =>
    !p.animateOut &&
    css`
      animation: ${catchClickAnimation} 1s linear forwards;
    `}
`
type Props = {
  items: any[]
}

const CategoryButtons: FC<Props> = ({ items }) => {
  const trackRef = useRef<HTMLElement>(null)
  const { onTouchEnd, prev, next, canMoveRight, canMoveLeft } = useSlider({
    trackRef,
    scrollAmount: 'full-width'
  })
  return (
    <Box
      width={{
        _: 'calc(100% - 0rem)',
        small: 'calc(100% - 2rem)',
        medium: 'calc(100% - 3rem)',
        xlarge: 'calc(100% - 5.5rem)'
      }}
      m="0 auto"
      maxWidth="109rem"
      borderTop={`1px solid ${theme.colors.shades[200]}`}
      py={['0.75rem', '1.5rem']}
      position="relative"
    >
      <Box display="flex">
        <NavBox
          width={['4rem', '7rem']}
          background="linear-gradient(90deg, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%)"
          left="0"
          opacity={canMoveLeft ? 1 : 0}
          style={{ pointerEvents: canMoveLeft ? 'all' : 'none' }}
          position="relative"
        >
          <CatchClick animateOut={canMoveLeft} left="0" />
          <SliderNavButton onClick={prev} direction="prev" />
        </NavBox>
        <NavBox
          justifyContent="flex-end"
          width={['3.25rem', '7rem']}
          background="linear-gradient(270deg, rgba(255,255,255,1) 50%, rgba(255,255,255,0) 100%)"
          right="0"
          opacity={canMoveRight ? 1 : 0}
          style={{ pointerEvents: canMoveRight ? 'all' : 'none' }}
          position="relative"
        >
          <CatchClick animateOut={canMoveRight} right="0" />
          <SliderNavButton onClick={next} direction="next" />
        </NavBox>
      </Box>
      <Box px={['1rem', 'initial']}>
        <Track ref={trackRef} onTouchEnd={onTouchEnd}>
          {items.map((item, index) => (
            <LocalizedLink href="/[...slug]" as={`/${item.elements.url_slug.value}`} key={index}>
              <CategoryLink
                image={
                  item.elements.logo
                    ? getKontentImage(item.elements.logo?.value[0]?.url, { width: 50 })
                    : null
                }
                href={`/${item.elements.url_slug.value}`}
                style={{ scrollSnapAlign: 'start' }}
              >
                {item.system.type === 'brand_page' ? (
                  <Text mb="0">{item.elements.title.value}</Text>
                ) : (
                  <Text mb="0">{item.elements.title.value}</Text>
                )}
              </CategoryLink>
            </LocalizedLink>
          ))}
        </Track>
      </Box>
    </Box>
  )
}

export default CategoryButtons
